import type { SectionConfig } from '../../lease-details.config';
import { FieldsRenderer } from '../fields-renderer';
import { SectionShell } from '../section-shell';

export type CoverageSectionProps = {
  config: SectionConfig;
};

// Structurally identical to `LeaseInformationSection` — kept separate so the
// four-section API in the engine stays explicit.
export const CoverageSection = ({ config }: CoverageSectionProps) => (
  <SectionShell title={config.title} subtitle={config.subtitle} slots={config.slots}>
    <FieldsRenderer fields={config.fields} sectionKey="coverage" />
  </SectionShell>
);
